module.exports = __webpack_public_path__ + "static/14-66cd852f289e386cb3de2257666f1943.jpg";